/**
 * Supabase Client Configuration
 * 
 * Initialize the Supabase client with credentials from environment variables.
 * This client is used throughout the app for database and storage operations.
 */

import { createClient } from '@supabase/supabase-js';

// Get credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

// Validate that credentials are present
if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error(
        'Missing Supabase credentials. Please check your .env file and ensure ' +
        'REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY are set.'
    );
}

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
});

// Helper function to handle Supabase errors
export const handleSupabaseError = (error) => {
    if (error) {
        console.error('Supabase Error:', error);
        // You can add more sophisticated error handling here
        // e.g., toast notifications, error logging service, etc.
        return {
            error: true,
            message: error.message || 'An unexpected error occurred',
            details: error,
        };
    }
    return null;
};

export default supabase;
